import UserContactInfoAccordion from './UserContactInfoAccordion';
import { IonAccordionGroup } from '@ionic/react';
import UserProfilePictureAccordion from './UserProfilePictureAccordion';
import PersonalKycAccordion from './PersonalKycAccordion';

export default function UserInformation() {
  return (
    <div className="space-y-4">
      <label className="font-medium high-emphasis-text">
        personal Information
      </label>
      <IonAccordionGroup className="border border-border overflow-hidden rounded-md">
        {/* USER INFORMATION */}
        <UserProfilePictureAccordion />
        <UserContactInfoAccordion />
        <PersonalKycAccordion />
      </IonAccordionGroup>
    </div>
  );
}
